import { AbstractPmsApiService } from "./abstract.service";
import { RegistrationCard } from "../models";

/**
 * @class RegistrationCardPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<RegistrationCard>}
 */
export class RegistrationCardPmsApiService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/property/:propertyId/registration-card';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {RegistrationCard}
     * @protected
     */
    newModel(attributes, ...params) {

        return new RegistrationCard(attributes);
    }

    /**
     * @param {Property} property
     * @returns {Promise.<RegistrationCard>}
     */
    get(property) {

        const url = this.url({propertyId: property.id});

        return this.http
                .get(url, {
                    headers: this.authHeaders
                })
                .then(this.getMassModeler())
                .catch(this.getErrorHandler());
    }

    /**
     * @param {Property} property
     * @param {RegistrationCard} RegistrationCard
     * @returns {Promise.<RegistrationCard>}
     */
    save(property, RegistrationCard, params = {}) {

        const url = this.url({propertyId: property.id});

        const ignorelb = params.ignorelb ? true: false;

        return this.http
                .post(url, RegistrationCard, {
                    headers: this.authHeaders,
                    ignoreLoadingBar: ignorelb,
                })
                .then(this.getModeler())
                .catch(this.getErrorHandler());
    }

    preview(property, language, fields) {

        const url = `${this.url({propertyId: property.id})}/preview`;

        return this.http
                .post(url, {language: language, fields: fields}, {
                    headers: this.authHeaders,
                })
                .then(this.getDataExtractor())
                .catch(this.getErrorHandler());
    }

    guestPreview(guest, property, reservation, params = {}) {

        const url = this.url({}, `/property/${property.id}/reservation/${reservation.id}/guest/${guest.id}/print-reg-card`);

        return this.http.post(url, Object.assign({is_child: guest.is_child}, params) , {
            headers: this.authHeaders
        })
        .then(this.getDataExtractor())
        .catch(this.getErrorHandler());
    }

    reservationsPreview(property, reservations, language) {

        const url = this.url({}, `/property/${property.id}/print-reg-cards`);

        const params = {reservations, language};

        return this.http.post(url, params, {
            headers: this.authHeaders
        })
            .then(this.getDataExtractor())
            .catch(this.getErrorHandler());
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/registration-card.service.js